import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import fr from "./fr.json";
import ar from "./ar.json";
import sw from "./sw.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      ar: { translation: ar },
      sw: { translation: sw },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "fr", "ar", "sw"],
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "sbc_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export const LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧", dir: "ltr" },
  { code: "fr", label: "Français", flag: "🇫🇷", dir: "ltr" },
  { code: "ar", label: "العربية", flag: "🇸🇦", dir: "rtl" },
  { code: "sw", label: "Kiswahili", flag: "🇰🇪", dir: "ltr" },
];

export default i18n;
